'use client'

import { useRouter, useSearchParams } from 'next/navigation'
import { ReactNode, useEffect } from 'react'

import { getAuthSession } from '@/services/auth-session-service'

export default function AuthRedirectGuard({ children }: { children: ReactNode }) {
  const searchParams = useSearchParams()
  const router = useRouter()

  useEffect(() => {
    const handleRedirect = async () => {
      const session = await getAuthSession()
      const user = session?.user
      const isOnboarding = !!searchParams.get('email') || !!searchParams.get('token')
      if (user && session.user?.status !== 'invited' && !isOnboarding) {
        router.push('/dashboard')
      }
    }

    handleRedirect()
  }, [searchParams, router])

  return children
}
